document.addEventListener("DOMContentLoaded", function () {
  console.log("=================================");
  console.log("DATE SORT DEBUG START");
  console.log("=================================");

  debugDateSorting();
});


function debugDateSorting() {

  /*
   * STEP 1
   * Find product grid
   */
  const productGrid = document.querySelector(
    "#items-grid"
  );

  console.log("STEP 1 - Product grid:");
  console.log(productGrid);


  if (!productGrid) {
    console.error(
      "❌ PRODUCT GRID NOT FOUND: #items-grid"
    );
    return;
  }


  /*
   * STEP 2
   * Find product cards
   */
  const products = Array.from(
    productGrid.querySelectorAll(".grid-item")
  );

  console.log("STEP 2 - Number of products found:");
  console.log(products.length);


  if (!products.length) {
    console.error(
      "❌ NO PRODUCTS FOUND USING .grid-item"
    );

    console.log(
      "Available elements inside product grid:",
      productGrid.children
    );

    return;
  }


  /*
   * STEP 3
   * Inspect every product
   */
  console.log("=================================");
  console.log("STEP 3 - PRODUCT DATA");
  console.log("=================================");


  products.forEach(function (product, index) {

    const dateContainer = product.querySelector(
      ".date-tag-container"
    );

    const dateAttribute = dateContainer
      ? dateContainer.getAttribute("data-available-dates")
      : null;


    console.log(
      `PRODUCT ${index + 1}`
    );

    console.log(
      "Product element:",
      product
    );

    console.log(
      "Date container:",
      dateContainer
    );

    console.log(
      "Raw date attribute:",
      dateAttribute
    );


    if (!dateAttribute) {
      console.warn(
        `⚠️ Product ${index + 1} has NO date data`
      );

      return;
    }


    try {

      const dates = JSON.parse(dateAttribute);

      console.log(
        "Parsed dates:",
        dates
      );


      /*
       * Convert dates to Date objects
       */
      const convertedDates = dates
        .map(function (date) {

          const converted = new Date(date);

          console.log(
            `Convert "${date}" →`,
            converted
          );

          return converted;

        })
        .filter(function (date) {

          return !isNaN(date.getTime());

        });


      console.log(
        "Valid dates:",
        convertedDates
      );


      /*
       * Sort dates
       */
      convertedDates.sort(function (a, b) {

        return a.getTime() - b.getTime();

      });


      console.log(
        "SORTED DATES:",
        convertedDates
      );


      /*
       * Earliest date
       */
      if (convertedDates.length) {

        console.log(
          "EARLIEST DATE:",
          convertedDates[0]
        );

      }

    } catch (error) {

      console.error(
        "❌ JSON PARSE ERROR:",
        error
      );

    }

    console.log("---------------------------------");

  });


  /*
   * STEP 4
   * Test product sorting
   */
  console.log("=================================");
  console.log("STEP 4 - SORTING PRODUCTS");
  console.log("=================================");


  const productsWithDates = products.map(function (product) {

    const dateContainer = product.querySelector(
      ".date-tag-container"
    );

    const dateAttribute = dateContainer
      ? dateContainer.getAttribute("data-available-dates")
      : null;


    let earliestDate = null;


    if (dateAttribute) {

      try {

        const dates = JSON.parse(dateAttribute);


        const validDates = dates
          .map(function (date) {

            return new Date(date);

          })
          .filter(function (date) {

            return !isNaN(date.getTime());

          });


        validDates.sort(function (a, b) {

          return a.getTime() - b.getTime();

        });


        if (validDates.length) {

          earliestDate = validDates[0];

        }

      } catch (error) {

        console.error(
          "Error processing product:",
          error
        );

      }

    }


    return {
      element: product,
      date: earliestDate
    };

  });


  /*
   * Print BEFORE sorting
   */
  console.log("BEFORE SORT:");

  productsWithDates.forEach(function (item, index) {

    console.log(
      index + 1,
      item.date
        ? item.date.toISOString()
        : "NO DATE"
    );

  });


  /*
   * Sort products
   */
  productsWithDates.sort(function (a, b) {

    if (!a.date && !b.date) {
      return 0;
    }

    if (!a.date) {
      return 1;
    }

    if (!b.date) {
      return -1;
    }

    return a.date.getTime() - b.date.getTime();

  });


  /*
   * Print AFTER sorting
   */
  console.log("AFTER SORT:");

  productsWithDates.forEach(function (item, index) {

    console.log(
      index + 1,
      item.date
        ? item.date.toISOString()
        : "NO DATE"
    );

  });


  /*
   * STEP 5
   * Rebuild product grid
   */
  productsWithDates.forEach(function (item) {

    productGrid.appendChild(item.element);

  });


  console.log("=================================");
  console.log("DATE SORT DEBUG COMPLETE");
  console.log("=================================");
}